import { isWebView, isAppVersionAtLeast } from '@/lib/utils/platform';

/**
 * Minimum app version where useRegisterWebview handles OPEN_CONNECT_ACCOUNT
 * during signup onboarding. Older native builds must fall through to the
 * web picker because they do not know how to open the native bank flow.
 */
const MIN_NATIVE_ONBOARDING_BANK_SELECTION_VERSION = '2.0.0';

/**
 * Send a postMessage to open native bank selection during onboarding.
 * Gated at 2.0.0: useRegisterWebview handles OPEN_CONNECT_ACCOUNT only from
 * 2.0.0. Below 2.0.0 the spinner blocks indefinitely, so fall through to web
 * picker.
 * Returns true if handled natively, false if web should render its picker.
 */
export function openNativeOnboardingBankSelection(): boolean {
  if (
    !isWebView() ||
    !isAppVersionAtLeast(MIN_NATIVE_ONBOARDING_BANK_SELECTION_VERSION)
  )
    return false;

  window.ReactNativeWebView!.postMessage(
    JSON.stringify({ type: 'OPEN_CONNECT_ACCOUNT' }),
  );
  return true;
}
